<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        @click="onOpen"
        v-on="on"
      >
        Configure Xero
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Configure Xero</v-card-title>

      <v-card-text>
        <v-col>
          <v-row>
            <v-btn
              elevation="2"
              :href="authorisationLink"
            >
              Connect to Xero
            </v-btn>
          </v-row>
          <v-row align-center>
            <v-select
              label="Selected Tenant"
              :items="payrollOptions.tenants"
              v-model="credentials.tenantId"
              :loading="loadingOptions"
              align-center
              item-text="tenantName"
              item-value="tenantId"
            />
            <v-btn color="success" @click="onUpdateTenants" icon class="mt-4">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-card-text>

      <v-divider></v-divider>

        <v-card-actions>
          <v-container
            v-if="saving"
          >
          Saving credentials...
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>

          </v-container>
          <v-spacer></v-spacer>
          <v-btn color="normal" text @click="dialog = false"> Cancel </v-btn>
          <v-btn color="primary"
            text
            @click="onSaveCredentials(credentials)"
            :disabled="saving"
          > Save </v-btn>
        </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialog: false,
      showPassword: false,
      // tenants: [],
      selectedTenant: null,
      clientId: '169D4F81EE064D0CB9BC2EC0ECC9DA38',
      loginUrl: 'https://login.xero.com/identity/connect/authorize',
      redirectUrl: `${window.location.origin}/payroll`,
      scopes: 'offline_access payroll.employees.read payroll.timesheets payroll.settings.read',
    };
  },
  props: {
    credentials: Object,
    saving: Boolean,
    businessId: String,
    payrollOptions: Object,
    loadingOptions: Boolean,
  },
  created() {
    const { code } = this.$route.query;
    if (code !== undefined) {
      // If redirected to this page with a code, pass it on to the API
      const url = window.location.href;
      this.onSaveCredentials({ url });
      this.$router.replace({ query: null });
    } else {
      this.onUpdateTenants();
    }
  },
  methods: {
    onSaveCredentials(credentials) {
      this.$emit('saveCredentials', credentials);
    },
    onOpen() {
      this.$emit('updateBusiness');
    },
    onUpdateTenants() {
      this.$emit('getOptions', 'tenants');
    },
    // async getTenants() {
    //   try {
    //     this.loadingTenants = true;
    //     const token = await this.$auth.getTokenSilently();
    //     const data = await BusinessService.getPayrollOptions(this.businessId, token, 'tenants');
    //     // this.tenants = data.map((tenant) => ({
    //     //   text: tenant.tenantName,
    //     //   value: tenant.tenantId,
    //     // }));
    //     this.loadingTenants = false;
    //   } catch (err) {
    //     console.log(`Couldn't get Xero tenants: ${err.message}`);
    //     // TODO: Display error (on parent?)
    //   }
    // },
  },
  computed: {
    authorisationLink() {
      return `${this.loginUrl}?response_type=code&client_id=${this.clientId}&redirect_uri=${this.redirectUrl}&scope=${this.scopes}`;
    },
    // tenants() {
    //   if (Array.isArray(this.payrollOptions.tenants)) {
    //     return this.payrollOptions.tenants;
    //   }
    //   return [];
    // },
  },
};
</script>

<style scoped>

</style>
